class OgerPackingVideo extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-video-open]');
    this.openButton.addEventListener('click', () => {
      if (!this.querySelector('video')) {
        this.querySelector('.oger-packing-video__player').append(
          this.querySelector('template').content.cloneNode(true)
        );
      }
      if (!this.dialog.open) this.dialog.showModal();
      this.querySelector('[data-video-close]').focus();
    }, options);
    this.querySelector('[data-video-close]').addEventListener('click', () => this.dialog.close(), options);
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const bounds = this.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) {
        this.dialog.close();
      }
    }, options);
    this.dialog.addEventListener('close', () => {
      this.querySelector('video')?.pause();
      if (this.isConnected) this.openButton.focus({ preventScroll: true });
    }, options);
  }

  disconnectedCallback() {
    this.querySelector('video')?.pause();
    if (this.dialog?.open) this.dialog.close();
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('oger-packing-video')) {
  customElements.define('oger-packing-video', OgerPackingVideo);
}
